// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stx {
  width: 480px;
  max-width: 92vw;
  margin-bottom: 0;
  font-size: 14px;
  color: #222b45;
}

.stx-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.stx-hint {
  font-size: 12.5px;
  color: #8f9bb3;
  line-height: 1.5;
}

.stx-strong {
  font-weight: 700;
  margin: 0 0 4px;
}

.stx-success {
  color: #00b887;
}

.stx-danger {
  color: #db2c66;
}

.stx-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
}

.stx-filename {
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stx-body {
  padding: 20px 24px 16px;
}

.stx-empty {
  height: 150px;
}

.stx ::ng-deep nb-spinner {
  background: transparent;
}

.stx-message {
  padding: 8px 0;
}
.stx-message p {
  margin: 0 0 8px;
}
.stx-message button {
  margin-top: 8px;
}

.stx-field {
  margin-bottom: 16px;
}
.stx-field:last-child {
  margin-bottom: 0;
}

.stx-label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
}

.stx-field-hint {
  display: flex;
  align-items: center;
  padding: 8px 0 0;
}
.stx-field-hint a {
  color: #13b5ea;
  text-decoration: none;
}
.stx-field-hint a:hover {
  text-decoration: underline;
}

.stx-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.stx-label-row .stx-label {
  margin-bottom: 6px;
}

.stx-refresh {
  background: none;
  border: none;
  padding: 2px;
  margin-bottom: 4px;
  line-height: 0;
  color: #8f9bb3;
  cursor: pointer;
}
.stx-refresh nb-icon {
  font-size: 16px;
}
.stx-refresh:hover {
  color: #13b5ea;
}

::ng-deep .stx-add-option {
  color: #13b5ea !important;
  border-top: 1px solid #edf1f7;
}
::ng-deep .stx-add-option .option-text,
::ng-deep .stx-add-option span {
  display: inline-flex;
  align-items: center;
}
::ng-deep .stx-add-option nb-icon {
  font-size: 15px;
  height: 15px;
  width: 15px;
  margin-left: 6px;
  flex-shrink: 0;
}

.stx-confirm {
  margin: 4px 0 0;
}
.stx-confirm b {
  color: #222b45;
  font-weight: 600;
}

.stx-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/home/xero/send-to-xero-dialog/send-to-xero-dialog.component.scss"],"names":[],"mappings":"AAMA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cARI;AAGN;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,iBAAA;EACA,cAlBK;EAmBL,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,aAAA;AAPF;;AAYA;EACE,uBAAA;AATF;;AAYA;EACE,cAAA;AATF;AAWE;EACE,eAAA;AATJ;AAYE;EACE,eAAA;AAVJ;;AAgBA;EACE,mBAAA;AAbF;AAeE;EACE,gBAAA;AAbJ;;AAiBA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,cArGQ;EAsGR,qBAAA;AAdJ;AAgBI;EACE,0BAAA;AAdN;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAhBF;AAkBE;EACE,kBAAA;AAhBJ;;AAoBA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,cA5HK;EA6HL,eAAA;AAjBF;AAmBE;EACE,eAAA;AAjBJ;AAoBE;EACE,cAtIQ;AAoHZ;;AAwBA;EACE,yBAAA;EACA,6BAAA;AArBF;AAuBE;;EAEE,oBAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAtBJ;;AA0BA;EACE,eAAA;AAvBF;AAyBE;EACE,cAlKE;EAmKF,gBAAA;AAvBJ;;AA6BA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;AA1BF;AACA,woKAAwoK","sourcesContent":["// Send-to-Xero dialog. Two type sizes only: base (14px) and hint (12.5px).\n\n$xero-blue: #13b5ea;\n$ink: #222b45;\n$hint: #8f9bb3;\n\n.stx {\n  width: 480px;\n  max-width: 92vw;\n  margin-bottom: 0;\n  font-size: 14px;\n  color: $ink;\n}\n\n.stx-title {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.stx-hint {\n  font-size: 12.5px;\n  color: $hint;\n  line-height: 1.5;\n}\n\n.stx-strong {\n  font-weight: 700;\n  margin: 0 0 4px;\n}\n\n.stx-success {\n  color: #00b887;\n}\n\n.stx-danger {\n  color: #db2c66;\n}\n\n// Layout\n\n.stx-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 24px;\n}\n\n.stx-filename {\n  max-width: 360px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stx-body {\n  padding: 20px 24px 16px;\n}\n\n.stx-empty {\n  height: 150px;\n}\n\n// nbSpinner paints a grey overlay over its host by default — on a clean white\n// dialog that reads as a weird grey panel. Keep the spinner, drop the veil.\n.stx ::ng-deep nb-spinner {\n  background: transparent;\n}\n\n.stx-message {\n  padding: 8px 0;\n\n  p {\n    margin: 0 0 8px;\n  }\n\n  button {\n    margin-top: 8px;\n  }\n}\n\n// Fields\n\n.stx-field {\n  margin-bottom: 16px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.stx-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.stx-field-hint {\n  display: flex;\n  align-items: center;\n  padding: 8px 0 0;\n\n  a {\n    color: $xero-blue;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.stx-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .stx-label {\n    margin-bottom: 6px;\n  }\n}\n\n.stx-refresh {\n  background: none;\n  border: none;\n  padding: 2px;\n  margin-bottom: 4px;\n  line-height: 0;\n  color: $hint;\n  cursor: pointer;\n\n  nb-icon {\n    font-size: 16px;\n  }\n\n  &:hover {\n    color: $xero-blue;\n  }\n}\n\n// nb-select options render inside a CDK overlay (outside this component's\n// DOM), hence ::ng-deep. Flex keeps the icon optically centered with the text.\n::ng-deep .stx-add-option {\n  color: $xero-blue !important;\n  border-top: 1px solid #edf1f7;\n\n  .option-text,\n  span {\n    display: inline-flex;\n    align-items: center;\n  }\n\n  nb-icon {\n    font-size: 15px;\n    height: 15px;\n    width: 15px;\n    margin-left: 6px;\n    flex-shrink: 0;\n  }\n}\n\n.stx-confirm {\n  margin: 4px 0 0;\n\n  b {\n    color: $ink;\n    font-weight: 600;\n  }\n}\n\n// Footer\n\n.stx-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 14px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
